import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import { lifecycle, branch, compose, renderComponent } from 'recompose'
import * as R from 'ramda'
import injectSagas from 'helpers/injectSagas'

import { reset } from './actions'
import {
  MODULE_NAME,
} from './constants'
import { to, redirect } from './selectors'
import sagas from './sagas'

const mapStateToProps = (state) => {
  return {
    to: to(state),
    redirect: redirect(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    reset: () => dispatch(reset())
  }
}

const isToMatchLocation = R.converge(R.equals, [
  R.path(['location', 'pathname']),
  R.prop('to')
])

const shouldRedirect = R.allPass([
  R.propEq('redirect', true),
  R.complement(isToMatchLocation)
])

const shouldReset = R.allPass([
  R.propEq('redirect', true),
  isToMatchLocation
])

const RedirectComponent = ({ to, redirect }) => <Redirect to={to}/>

const withRedirect = compose(
  lifecycle({
    componentDidUpdate() {
      if (shouldReset(this.props)) this.props.reset()
    }
  }),
  branch(
    shouldRedirect,
    renderComponent(RedirectComponent)
  )
)

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: sagas})

const enhance = compose(
  withRouter,
  withSagas,
  withConnect,
  withRedirect
)

export default enhance
